'use client';

import { useEffect, useState } from 'react';
import dayjs from 'dayjs';
import { ClockIcon } from 'lucide-react';

interface DiscountCountdownProps {
  endTime: string;
}

function calcRemaining(endTime: string) {
  const diff = dayjs(endTime).diff(dayjs(), 'second');
  if (diff <= 0) return null;
  const days = Math.floor(diff / 86400);
  const hours = Math.floor((diff % 86400) / 3600);
  return { days, hours };
}

export default function DiscountCountdown({
  endTime,
}: DiscountCountdownProps) {
  const [remaining, setRemaining] = useState(() => calcRemaining(endTime));

  useEffect(() => {
    const timer = setInterval(() => {
      const r = calcRemaining(endTime);
      setRemaining(r);
      if (!r) clearInterval(timer);
    }, 1000);
    return () => clearInterval(timer);
  }, [endTime]);

  if (!remaining) return null;

  const { days, hours } = remaining;
  const timeStr = days > 0 ? `${days} 天` : `${hours} 小时`;

  return (
    <span className="inline-flex items-center gap-1 text-orange-700 dark:text-orange-300">
      <ClockIcon className="w-3 h-3" />
      <span>优惠价剩余约</span>
      <span className="tabular-nums">{timeStr}</span>
    </span>
  );
}
